module.exports = __webpack_public_path__ + "img/shareLogo.ca0bc323.png";